<!-- <p>wall works!</p> -->
<div class="designView active">
  <div class="DSA_mainwrapper">
    @if (userDetailsData) {
      <app-header
        [roles]="roles"
        [entities]="entities"
        [entityRoles]="entityRoles"
        [roleAndFeatures]="roleAndFeatures"
        (homeEvent)="homeEvent($event)"
        [links]="links"
        [userDetailsData]="userDetailsData"
        (maintenanceMode)="checkMaintenanceMode($event)"
      />
    }
    @if (!maintenanceEnabled) {
      <div class="DSA_baseLayout_center padT" style="margin-bottom: 20px">
        <router-outlet />
      </div>
    }
  </div>
</div>
